import React, { useEffect, useState } from "react";
import { getAllSubsites, allSubsites, subsiteTotalCount } from '../../reducers/subsite';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import MSMPagination from '../MSMPagination';
import CreateSubsiteModal from '../modals/CreateSubsiteModal';
import Button from "react-bootstrap/Button";
import { PersonCircle, Diagram2, Cart, Search } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import Form from "react-bootstrap/Form";
import { Formik } from 'formik';
import * as Yup from 'yup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SubsiteService from "../../services/subsite.service";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const AdminPriceCalculation = () => {
  const subsites = useSelector(allSubsites);
  const subsiteStatus = useSelector(state => state.subsite.status);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [tier1Max, setTier1Max] = useState(0);
  const [tier1Factor, setTier1Factor] = useState(0);
  const [tier1Fixed, setTier1Fixed] = useState(0);
  const [tier2Max, setTier2Max] = useState(0);
  const [tier2Factor, setTier2Factor] = useState(0);
  const [tier2Fixed, setTier2Fixed] = useState(0);
  const [tier3Max, setTier3Max] = useState(0);
  const [tier3Factor, setTier3Factor] = useState(0);
  const [tier3Fixed, setTier3Fixed] = useState(0);
  const [tier4Max, setTier4Max] = useState(0);
  const [tier4Factor, setTier4Factor] = useState(0);
  const [tier4Fixed, setTier4Fixed] = useState(0);
  const [tier5Max, setTier5Max] = useState(0);
  const [tier5Factor, setTier5Factor] = useState(0);
  const [tier5Fixed, setTier5Fixed] = useState(0);

  let perPage = 10;
  

  useEffect(() => {
    SubsiteService.getSubsitePriceCalculation().then((response) => {
      setTier1Max(response.data.tier1Max);
      setTier1Factor(response.data.tier1Factor);
      setTier1Fixed(response.data.tier1Fixed);
      setTier2Max(response.data.tier2Max);
      setTier2Factor(response.data.tier2Factor);
      setTier2Fixed(response.data.tier2Fixed);
      setTier3Max(response.data.tier3Max);
      setTier3Factor(response.data.tier3Factor);
      setTier3Fixed(response.data.tier3Fixed);
      setTier4Max(response.data.tier4Max);
      setTier4Factor(response.data.tier4Factor);
      setTier4Fixed(response.data.tier4Fixed);
      setTier5Max(response.data.tier5Max);
      setTier5Factor(response.data.tier5Factor);
      setTier5Fixed(response.data.tier5Fixed);
    });
  }, []);

  const savePricing = () => {
    SubsiteService.updateSubsitePriceCalculation({
      tier1Max: tier1Max,
      tier1Factor: tier1Factor,
      tier1Fixed: tier1Fixed,
      tier2Max: tier2Max,
      tier2Factor: tier2Factor,
      tier2Fixed: tier2Fixed,
      tier3Max: tier3Max,
      tier3Factor: tier3Factor,
      tier3Fixed: tier3Fixed,
      tier4Max: tier4Max,
      tier4Factor: tier4Factor,
      tier4Fixed: tier4Fixed,
      tier5Max: tier5Max,
      tier5Factor: tier5Factor,
      tier5Fixed: tier5Fixed
    });
  }

  return (
    <div className="user-details-container">
        <Container  className="user-data">
          <Row>
              <Col className="icon">
                        <h2>Pricing Rules</h2>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Range</th>
                              <th>Calculation</th>
                              <th>Example</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>&lt;= ${tier1Max}</td>
                              <td>price * {tier1Factor} + ${tier1Fixed}</td>
                              <td>${tier1Max} * {tier1Factor} + {tier1Fixed} = {parseFloat(tier1Max * tier1Factor) + parseFloat(tier1Fixed)}</td>
                            </tr>
                            <tr>
                              <td>&lt;= ${tier2Max}</td>
                              <td>price * {tier2Factor} + ${tier2Fixed}</td>
                              <td>${tier2Max} * {tier2Factor} + {tier2Fixed} = {tier2Max * tier2Factor + tier2Fixed}</td>
                            </tr>
                            <tr>
                              <td>&lt;= ${tier3Max}</td>
                              <td>price * {tier3Factor} + ${tier3Fixed}</td>
                              <td>${tier3Max} * {tier3Factor} + {tier3Fixed} = {tier3Max * tier3Factor + tier3Fixed}</td>
                            </tr>
                            <tr>
                              <td>&lt;= ${tier4Max}</td>
                              <td>price * {tier4Factor} + ${tier4Fixed}</td>
                              <td>${tier4Max} * {tier4Factor} + {tier4Fixed} = {tier4Max * tier4Factor + tier4Fixed}</td>
                            </tr>
                            <tr>
                              <td>&lt;= ${tier5Max}</td>
                              <td>price * {tier5Factor} + ${tier5Fixed}</td>
                              <td>${tier4Max + 50} * {tier5Factor} + {tier5Fixed} = {(tier4Max + 50) * tier5Factor + tier5Fixed}</td>
                            </tr>
                          </tbody>
                        </table>
                       
            </Col>
            </Row>
            <Row>
              <Col>
                <h3>Tier 1</h3>
                <Form.Group>
                  <Form.Label>Maximum Amount</Form.Label>
                  <Form.Control type="number" value={tier1Max} onChange={(e) => setTier1Max(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Multiplier</Form.Label>
                  <Form.Control type="number" value={tier1Factor} onChange={(e) => setTier1Factor(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Fixed Amount</Form.Label>
                  <Form.Control type="number" value={tier1Fixed} onChange={(e) => setTier1Fixed(e.target.value)} />
                </Form.Group>
              </Col>

              <Col>
                <h3>Tier 2</h3>
                <Form.Group>
                  <Form.Label>Maximum Amount</Form.Label>
                  <Form.Control type="number" value={tier2Max} onChange={(e) => setTier2Max(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Multiplier</Form.Label>
                  <Form.Control type="number" value={tier2Factor} onChange={(e) => setTier2Factor(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Fixed Amount</Form.Label>
                  <Form.Control type="number" value={tier2Fixed} onChange={(e) => setTier2Fixed(e.target.value)} />
                </Form.Group>
              </Col>

              <Col>
                <h3>Tier 3</h3>
                <Form.Group>
                  <Form.Label>Maximum Amount</Form.Label>
                  <Form.Control type="number" value={tier3Max} onChange={(e) => setTier3Max(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Multiplier</Form.Label>
                  <Form.Control type="number" value={tier3Factor} onChange={(e) => setTier3Factor(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Fixed Amount</Form.Label>
                  <Form.Control type="number" value={tier3Fixed} onChange={(e) => setTier3Fixed(e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <h3>Tier 4</h3>
                <Form.Group>
                  <Form.Label>Maximum Amount</Form.Label>
                  <Form.Control type="number" value={tier4Max} onChange={(e) => setTier4Max(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Multiplier</Form.Label>
                  <Form.Control type="number" value={tier4Factor} onChange={(e) => setTier4Factor(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Fixed Amount</Form.Label>
                  <Form.Control type="number" value={tier4Fixed} onChange={(e) => setTier4Fixed(e.target.value)} />
                </Form.Group>
              </Col>

              <Col>
                <h3>Tier 5</h3>
                <Form.Group>
                  <Form.Label>Maximum Amount</Form.Label>
                  <Form.Control type="number" value={tier5Max} onChange={(e) => setTier5Max(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Multiplier</Form.Label>
                  <Form.Control type="number" value={tier5Factor} onChange={(e) => setTier5Factor(e.target.value)} />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Fixed Amount</Form.Label>
                  <Form.Control type="number" value={tier5Fixed} onChange={(e) => setTier5Fixed(e.target.value)} />
                </Form.Group>
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>
              <Button onClick={savePricing}>Save Pricing Rules</Button>

              </Col>
            </Row>
      </Container>
    </div>
  );
};
export default AdminPriceCalculation;

